import { ref, onMounted } from 'vue';
import axios from 'axios';

const backend_url = import.meta.env.VITE_API_URL;

export function useCampaigns() {
  const Campaigns = ref([]);

  const fetchCampaigns = async () => {
    try {
      const response = await axios.get(`${backend_url}/campaign`);
      Campaigns.value = response.data;
    } catch (error) {
      console.error('Error fetching campaigns:', error);
    }
  };

  onMounted(fetchCampaigns);

  return {
    Campaigns,
  };
}
